import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/desktop/leaves_1048x1116.webp")